import { handleActions } from 'redux-actions';

import { reportStoreTypes, reportUpserters, resourceUpserters } from '../core';

import * as actions from './accountsValueChangesActions';

const reducer = handleActions(
  {
    [actions.getAccountsValueChanges()]: (state) => state.set('isLoading', true),

    [actions.getAccountsValueChangesSuccess]: (state, { payload }) => reportUpserters.upsertReports(state, payload),

    [actions.getAccountsValueChangesFailure]: (state, { payload: error }) =>
      resourceUpserters.completeWithError(state, error),
  },
  reportStoreTypes.mkReportStore(),
);

export default reducer;
